import Axios from 'middleware/axiosInstance'
import React, { useEffect, useState } from 'react'
import { Button, Space, Table, message, Card, Typography } from "antd";
import { useNavigate } from 'react-router-dom';
import Loading from 'layouts/Loading/Loading';
import './CategorySorting.scss';
import { getCategoryListFromResponse } from 'functions/functions';

const { Title, Text } = Typography;

const CategorySorting = () => {
    const navigate = useNavigate();

    const [allCategories, setAllCategories] = useState([]);
    const [hasOrderChanged, setHasOrderChanged] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const getAllCategories = () => {
        Axios.get("/category")
            .then((res) => {
                setAllCategories(getCategoryListFromResponse(res.data) || []);
            })
            .catch(err => {
                console.log(err);
                message.error('خطا در بارگذاری لیست دسته‌بندی‌ها');
            });
    };

    useEffect(() => {
        getAllCategories();
    }, []);

    // Handle drag and drop with HTML5 API
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('text/plain', index);
        e.target.style.opacity = '0.5';
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();
        const dragIndex = parseInt(e.dataTransfer.getData('text/plain'));
        
        if (dragIndex !== dropIndex) {
            const newCategories = [...allCategories];
            const [draggedItem] = newCategories.splice(dragIndex, 1);
            newCategories.splice(dropIndex, 0, draggedItem);
            
            setAllCategories(newCategories);
            setHasOrderChanged(true);
        }
        
        e.target.style.opacity = '1';
    };

    const handleDragEnd = (e) => {
        e.target.style.opacity = '1';
    };

    // Submit new order to backend
    const submitNewOrder = async () => {
        if (!hasOrderChanged) {
            message.info('ترتیب تغییر نکرده است');
            return;
        }

        setIsSubmitting(true);
        try {
            const orderData = allCategories.map((category, index) => ({
                id: category.id,
                order: index
            }));

            const response = await Axios.post('/category/reorder', orderData);
            
            if (response.status === 200) {
                message.success('ترتیب با موفقیت ذخیره شد');
                setHasOrderChanged(false);
            }
        } catch (error) {
            console.error('Error updating order:', error);
            message.error('خطا در ذخیره ترتیب');
        } finally {
            setIsSubmitting(false);
        }
    };

    const columns = [
        {
            title: "ترتیب",
            dataIndex: "order",
            key: "order",
            width: 80,
            render: (_, record, index) => (
                <div className="order-number">
                    {index + 1}
                </div>
            ),
        },
        {
            title: "نام دسته‌بندی",
            dataIndex: "title_fa",
            key: "title_fa",
            sorter: (a, b) =>
                a.title_fa > b.title_fa ? 1 : b.title_fa > a.title_fa ? -1 : 0,
            ellipsis: true,
        },
        {
            title: "دسته والد",
            dataIndex: "parent_id",
            key: "parent_id",
            render: (_, item) => (
                <span>{item.parent?.title_fa || 'اصلی'}</span>
            ),
        },
    ];

    const sortedCategories = allCategories.map(({ children, children_recursive, food, ...category }) => category);

    return (
        <div className="customized-container category-sorting-page">
            <div className="customized-wrapper">
                <Card>
                    <div className="page-header">
                        <Title level={3}>مرتب‌سازی دسته‌بندی‌ها</Title>
                        <Text type="secondary">
                            برای تغییر ترتیب دسته‌بندی‌ها، روی هر ردیف کلیک کرده و آن را به موقعیت جدید بکشید
                        </Text>
                    </div>

                    <div className="action-buttons">
                        <Space>
                            <Button 
                                type="primary" 
                                onClick={submitNewOrder}
                                loading={isSubmitting}
                                disabled={!hasOrderChanged}
                            >
                                ذخیره ترتیب جدید
                            </Button>
                            <Button 
                                onClick={() => {
                                    setHasOrderChanged(false);
                                    getAllCategories();
                                }}
                            >
                                بازنشانی
                            </Button>
                            <Button onClick={() => navigate('/categories')}>
                                بازگشت به لیست دسته‌بندی‌ها
                            </Button>
                        </Space>
                    </div>

                    {/* Info */}
                    {hasOrderChanged && (
                        <div className="info-alert">
                            <Text type="success">
                                ⚠️ ترتیب تغییر کرده است. برای ذخیره تغییرات روی "ذخیره ترتیب جدید" کلیک کنید.
                            </Text>
                        </div>
                    )}

                    {allCategories.length > 0 ? (
                        <div className="sorting-table">
                            <Table
                                pagination={false}
                                columns={columns}
                                dataSource={sortedCategories}
                                rowKey="id"
                                onRow={(record, index) => ({
                                    draggable: true,
                                    onDragStart: (e) => handleDragStart(e, index),
                                    onDragOver: (e) => handleDragOver(e),
                                    onDrop: (e) => handleDrop(e, index),
                                    onDragEnd: handleDragEnd,
                                    style: { cursor: 'grab' },
                                    className: 'draggable-row',
                                })}
                            />
                        </div>
                    ) : (
                        <div className="loading-container">
                            <Loading />
                        </div>
                    )}
                </Card>
            </div>
        </div>
    );
};

export default CategorySorting;
